import { render, staticRenderFns } from "./JaarlijkseOpvolgingTable.vue?vue&type=template&id=4c7ded2b&scoped=true"
import script from "./JaarlijkseOpvolgingTable.vue?vue&type=script&lang=js"
export * from "./JaarlijkseOpvolgingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ded2b",
  null
  
)

export default component.exports